import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.laboratoryModule'),
    id: 'laboratoryModule',
    sidebar: [
        {
            id: 'operations',
            label: i18n.tc('configuration.sections.operation', 2),
            icon: 'far fa-line-height',
            routeName: 'LaboratoryOperations',
            hasChildren: false
        },
        {
            id: 'sections',
            label: i18n.tc('configuration.sections.section', 2),
            icon: 'far fa-list-ul',
            routeName: 'LaboratorySections',
            hasChildren: false
        },
        {
            id: 'subportion-state-machines',
            label: i18n.tc('configuration.sections.stateMachine', 2),
            icon: 'fas fa-tags',
            routeName: 'SubportionStateMachines',
            hasChildren: false
        }
    ]
}
